import { render, staticRenderFns } from "./blackDetail.vue?vue&type=template&id=d2c36b70&scoped=true&"
import script from "./blackDetail.vue?vue&type=script&lang=js&"
export * from "./blackDetail.vue?vue&type=script&lang=js&"
import style0 from "./blackDetail.vue?vue&type=style&index=0&id=d2c36b70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c36b70",
  null
  
)

export default component.exports